import * as React from "react";

export default ({
  title,
  subtitle,
  desc,
  desc2,
  validation,
  confirmation,
  inscription,
  vote,
  checkEmail,
}: any) => {
  const [seeModalValidation, setSeeModalValidation] =
    React.useState<any>(false);
  const [seeModalConfirmation, setSeeModalConfirmation] =
    React.useState<any>(false);
  const [seeModalInscription, setSeeModalInscription] =
    React.useState<any>(false);
  const [seeModalVote, setSeeModalVote] = React.useState<any>(false);
  const [seeModalResendEmail, setSeeModalResendEmail] =
    React.useState<any>(false);
  React.useEffect(() => {
    {
      validation ? setSeeModalValidation(true) : setSeeModalValidation(false);
    }
    {
      confirmation
        ? setSeeModalConfirmation(true)
        : setSeeModalConfirmation(false);
    }
    {
      inscription
        ? setSeeModalInscription(true)
        : setSeeModalInscription(false);
    }
    {
      vote == 1 ? setSeeModalVote(true) : setSeeModalVote(false);
    }
    {
      checkEmail ? setSeeModalResendEmail(true) : setSeeModalResendEmail(false);
    }
    history.pushState(null, "", "dia-del-agua");
  }, []);

  const closeModalValidation = () => {
    setSeeModalValidation(false);
    const API_URL =
      window.location.protocol +
      `//` +
      window.location.host +
      "/aguas/unset/sessions/newuser";
    fetch(API_URL, {
      method: "GET",
    })
      .then((response) => response.json())
      .then((response) => {
        setSeeModalValidation(false);
      })
      .catch(function (error) {});
  };

  const closeModalConfirmation = () => {
    const API_URL =
      window.location.protocol +
      `//` +
      window.location.host +
      "/aguas/unset/sessions/activateuser";
    fetch(API_URL, {
      method: "GET",
    })
      .then((response) => response.json())
      .then((response) => {
        setSeeModalConfirmation(false);
      })
      .catch(function (error) {});
  };

  const closeModalInscription = () => {
    const API_URL =
      window.location.protocol +
      `//` +
      window.location.host +
      "/aguas/unset/sessions/userparticipate";
    fetch(API_URL, {
      method: "GET",
    })
      .then((response) => response.json())
      .then((response) => {
        setSeeModalInscription(false);
      })
      .catch(function (error) {});
  };

  const closeModalVote = () => {
    localStorage.setItem("userVoted", "0");
    const API_URL =
      window.location.protocol +
      `//` +
      window.location.host +
      "/aguas/unset/sessions/sessiongallery";
    fetch(API_URL, {
      method: "GET",
    })
      .then((response) => response.json())
      .then((response) => {
        setSeeModalVote(false);
      })
      .catch(function (error) {});
  };

  const closeModalEmail = () => {
    const API_URL =
      window.location.protocol +
      `//` +
      window.location.host +
      "/aguas/unset/sessions/sessiongallery";
    fetch(API_URL, {
      method: "GET",
    })
      .then((response) => response.json())
      .then((response) => {
        setSeeModalResendEmail(false);
      })
      .catch(function (error) {});
  };

  return (
    <>
      <div className={`modalInfo ${seeModalValidation ? "display-modal" : ""}`}>
        <div className="modalInfo-container">
          <div className="modalInfo-container--header">
            <h2 className="header-title">{title}</h2>
            <p className="header-subtitle">{subtitle}</p>
          </div>
          <div className="modalInfo-container--body">
            <p className="body-desc">{desc}</p>
            <a onClick={closeModalValidation} className="body-btn body-btn-1">
              Aceptar
            </a>
          </div>
        </div>
      </div>

      <div
        className={`modalInfo ${seeModalConfirmation ? "display-modal" : ""}`}
      >
        <div className="modalInfo-container">
          <div className="modalInfo-container--header">
            <h2 className="header-title">{title}</h2>
            <p className="header-subtitle">{subtitle}</p>
          </div>
          <div className="modalInfo-container--body">
            <p className="body-desc">{desc}</p>
            <a
              href="/participar"
              onClick={closeModalConfirmation}
              className="body-btn body-btn-1"
            >
              Inscribir
            </a>
            <a
              href="/galeria"
              onClick={closeModalConfirmation}
              className="body-btn body-btn-2"
            >
              Votar
            </a>
          </div>
        </div>
      </div>

      <div
        className={`modalInfo ${seeModalInscription ? "display-modal" : ""}`}
      >
        <div className="modalInfo-container">
          <div className="modalInfo-container--header">
            <h2 className="header-title">{title}</h2>
            <p className="header-subtitle">{subtitle}</p>
          </div>
          <div className="modalInfo-container--body">
            <p className="body-desc-2">{desc}</p>
            <p className="body-desc-2">{desc2}</p>
            <a
              href="/participar"
              onClick={closeModalInscription}
              className="body-btn body-btn-1"
            >
              Inscribir
            </a>
            <a
              href="/galeria"
              onClick={closeModalInscription}
              className="body-btn body-btn-2"
            >
              Votar
            </a>
          </div>
        </div>
      </div>

      <div className={`modalInfo ${seeModalVote ? "display-modal" : ""}`}>
        <div className="modalInfo-container">
          <div className="modalInfo-container--header">
            <h2 className="header-title">{title}</h2>
            <p className="header-subtitle">{subtitle}</p>
          </div>
          <div className="modalInfo-container--body">
            <p className="body-desc">{desc}</p>
            <a onClick={closeModalVote} className="body-btn body-btn-1">
              Aceptar
            </a>
          </div>
        </div>
      </div>

      <div
        className={`modalInfo ${seeModalResendEmail ? "display-modal" : ""}`}
      >
        <div className="modalInfo-container">
          <div className="modalInfo-container--header">
            <h2 className="header-title">{title}</h2>
            <p className="header-subtitle">{subtitle}</p>
          </div>
          <div className="modalInfo-container--body">
            <p className="body-desc">{desc}</p>
            <a onClick={closeModalEmail} className="body-btn body-btn-1">
              Aceptar
            </a>
          </div>
        </div>
      </div>
    </>
  );
};
